import "./HomePage.css";
import Hero from "../../components/Hero/Hero";
import Features from "../../components/Features/Features";

export default function HomePage() {
  return (
    <div className="home-page">
      <Hero />
      <Features />
    </div>
  );
}
